<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" ref="notificationOpenBtn">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="get_unread_notification" />

    <!-- <pre>{{notificationListData}}</pre> -->

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ get_unread_notification }} New</h3>
        <p class="opacity-75">App Notifications</p>
        <!-- <pre>{{notificationListData}}</pre> -->
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <!-- <ul class="bordered-items">
          <li v-for="ntf in unreadNotifications" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer">
            <div class="flex items-start">
              <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                <small>{{ ntf.msg }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.time) }}</small>
          </li>
        </ul> -->
          <ul class="bordered-items">
            
          <li v-for="(eachNotification,index) in notificationListData" :key="index" class="flex justify-between px-4 notification cursor-pointer" :class="eachNotification.is_read ? 'unread':'read'">
            <div class="flex items-center w-full">
              <!-- {{eachNotification}} -->
              <!-- {{eachNotification}} -->
              <feather-icon icon="MessageSquareIcon" :svgClasses="[`text-primary`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2 w-full">
                <!-- If Not read -->
                 <p class="py-4" style="font-size: 11.667px; font-weight: 500; letter-spacing: 0.14px; line-height: 17.5px;"
                  v-if="eachNotification.is_read"
                  @click="
                    redirectToRespectivePath(eachNotification,index,true)
                  "
                  > {{ eachNotification.notification_details }}
                </p>
                
                <p class="py-4" style="font-size: 11.667px; font-weight: 500; letter-spacing: 0.14px; line-height: 17.5px;"
                  @click="redirectToRespectivePath(eachNotification)"
                  v-else
                >
                   {{ eachNotification.notification_details }}
                </p>
              <!--   <span @click="redirectToRespectivePath(eachNotification)">
                <span class="font-medium block notification-title" :class="[`text-primary`]"></span>
                <small>{{ eachNotification.notification_details }}</small>
                </span> -->
              </div>
            </div>
            <!-- <small class="mt-1 whitespace-no-wrap">{{ (eachNotification.created_at) }}</small> -->
          </li>
        </ul>
      </component>
      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <router-link to="/pages/notification">
        <span>View All Notifications</span>
        </router-link>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {NotificationMixins} from '@/mixins/common/NotificationMixins.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    VuePerfectScrollbar
  },
  mixins:[NotificationMixins],
  
  // mounted () {
  //   
  //   this.pusher = new Pusher('88eaad21e4874b16bb68', {
  //     encrypted: true,
  //     cluster: 'ap2'
  //   })
  //   this.channel = this.pusher.subscribe('test-notification')
  //   this.channel.bind('Notifications.create', (data) => {
  //     this.$vs.notify({
  //       title: 'Success',
  //       text:   `pusher message ${data}`,
  //       iconPack: 'feather',
  //       icon: 'icon-alert-circle',
  //       color: 'success'
  //     })
  //   })
  // },
  data () {
    return {
   
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    ...mapGetters(['get_unread_notification']),

    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {

  }
}

</script>

<style>
.notification.unread {
  font-weight: bold;
}
.notification.unread svg {
  stroke: #FF9F43 !important;
}
</style>

